import React from 'react';
import PropTypes from 'prop-types';

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import cellEditFactory from 'react-bootstrap-table2-editor';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faTrash,
    faWindowRestore
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(faTrash);
library.add(faWindowRestore)


const DeviceTable = ({
    type,
    indexStart,
    items,
    onDevActionClicked,
    updateDeviceCallerId,
    onCallerIdUpdated
}) => {

    let otpHidden = false;
    let exitCodeHidden = false;

    if (type === 'actives') {
        otpHidden = true
    }
    if (type === 'inactives') {
        otpHidden = true
        exitCodeHidden = true
    }
    if (type === 'pendings') {
        exitCodeHidden = true
    }

    let columns = [
        {
            dataField: 'id',
            text: '#',
            headerClasses: "table-col-head",
            hidden: true,
            editable: false
        },
        {
            dataField: 'no',
            text: 'No.',
            headerClasses: "table-col-head",
            hidden: false,
            editable: false,
            headerStyle: () => {
                return { width: '5%', textAlign: 'center', whiteSpace: 'nowrap' };
            }
        }, {
            dataField: 'username',
            text: 'Serial No.',
            headerClasses: "table-col-head w-50 w-md-25",
        }, {
            dataField: 'callerId',
            text: 'Caller ID',
            headerClasses: "table-col-head",
            sort: true,
            editable: true,
            headerStyle: () => {
                return { width: '15%', textAlign: 'center', whiteSpace: 'nowrap' };
            }
        },
        {
            dataField: 'pinNumber',
            text: 'OTP',
            headerClasses: "table-col-head",
            sort: true,
            hidden: otpHidden,
            editable: false,
            headerStyle: () => {
                return { width: '10%', textAlign: 'center', whiteSpace: 'nowrap' };
            }
        },
        {
            dataField: 'masterPwd',
            text: 'Exit Code',
            headerClasses: "table-col-head",
            sort: true,
            editable: false,
            hidden: exitCodeHidden,
            headerStyle: () => {
                return { width: '10%', textAlign: 'center', whiteSpace: 'nowrap' };
            }
        },
        {
            dataField: 'action',
            text: 'Action',
            headerClasses: "table-col-head",
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row, rowIndex, extraData) => {
                if (extraData.type === 'actives' || extraData.type === 'pendings') {
                    return (
                        <div className="text-center">
                            <label>
                                <FontAwesomeIcon color='red' icon='trash'></FontAwesomeIcon>
                            </label>
                        </div>
                    )
                }
                if (extraData.type === 'inactives') {
                    return (
                        <div className="text-center">
                            <label>
                                <FontAwesomeIcon color='green' icon='window-restore'></FontAwesomeIcon>
                            </label>
                        </div>
                    )
                }
            },
            formatExtraData: { type: type },
            editable: false,
            events: {
                onClick: (e, columns, columnIndex, row) => {
                    onDevActionClicked(type, items.byid[row.username.toLowerCase()])
                }
            },
            headerStyle: () => {
                return { width: '20%', textAlign: 'center', whiteSpace: 'nowrap' };
            }
        }
    ];

    let data = []
    let count = indexStart + 1;
    items.list.forEach((dev) => {
        let item = {}
        item['no'] = count
        item['username'] = dev.toUpperCase()
        item['callerId'] = items.byid[dev].callerId
        item['pinNumber'] = items.byid[dev].pinNumber
        item['masterPwd'] = items.byid[dev].masterPwd
        data.push(item);
        count++;
    })
    return (
        <BootstrapTable
            classes="table-md table-responsive-sm text-center align-middle"
            keyField='username'
            data={data}
            columns={columns}
            striped
            condensed
            bordered={false}
            noDataIndication="Record not found"
            cellEdit={cellEditFactory({
                mode: 'click',
                afterSaveCell: (oldValue, newValue, row) => {
                    // console.log(row.username)
                    let dev = items.byid[row.username.toLowerCase()]
                    updateDeviceCallerId(dev.id, newValue).then((res) => { onCallerIdUpdated(res) })
                }
            })}
        />
    )
};

DeviceTable.propTypes = {
    type: PropTypes.string,
    indexStart: PropTypes.number,
    items: PropTypes.object,
    onDevActionClicked: PropTypes.func,
    updateDeviceCallerId: PropTypes.func,
    onCallerIdUpdated: PropTypes.func
};

export default DeviceTable;



// WEBPACK FOOTER //
// ./src/components/blocks/DeviceTable/DeviceTable.js